export default __webpack_public_path__ + "static/media/earth2.990ac782.png";